// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".number[data-v-094298a4]{font-size:80px!important;width:50px;color:#d3d3d3}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
